import { isEmpty } from "lodash";

const buildQueryString = (payload: any): string => {
  if (isEmpty(payload)) return "";
  return Object.keys(payload)
    .map((key) => {
      let val = payload[key];
      if (val !== null && typeof val === "object") val = buildQueryString(val);
      if (val) {
        return `${key}=${encodeURIComponent(`${val}`.replace(/\s/g, " "))}`;
      }
    })
    .filter((item: any) => !!item)
    .join("&");
};

export { buildQueryString };
